/**
 * Konsolidering av bloggen: tunna eller dubblerade inlägg pekas om (301) till
 * den djupa, kompletta guiden om samma ämne. Syftet är att stoppa
 * keyword-kannibalisering — flera sidor som slåss om samma sökord — och
 * samla länkkraft och CTR på en enda stark URL.
 *
 * Nyckel = gammal slug (avpublicerad), värde = slug som ska rankas.
 */
export const BLOG_REDIRECTS: Record<string, string> = {
  // Köpa begagnat – fyra varianter av samma checklista
  "kopa-begagnad-husbil-checklista-fran-verkstaden-2026-2026-08-25":
    "kopa-begagnad-husbil-checklista-fran-verkstaden-2026",
  "kopa-begagnad-husbil-checklista-verkstaden": "kopa-begagnad-husbil-checklista-fran-verkstaden-2026",
  "begagnad-husbil-checklista": "kopa-begagnad-husbil-checklista-fran-verkstaden-2026",
  "kopa-begagnad-husbil-20-varningsflaggor": "kopa-begagnad-husbil-checklista-fran-verkstaden-2026",

  // Husbilstyper
  "valja-ratt-husbilstyp-alkov-halvintegrerad-integrerad":
    "valja-ratt-husbil-alkov-halvintegrerad-helintegrerad-guide",

  // El, solceller och batteri
  "solceller-husbil-guide": "smart-elsystem-husbil-solcell-litium-batteri-frihet",
  "solceller-husbil-guide-2026": "smart-elsystem-husbil-solcell-litium-batteri-frihet",
  "litiumbatteri-husbil-vs-agm-gel-2026": "smart-elsystem-husbil-solcell-litium-batteri-frihet",
  "elfel-glassakring-bodel-husbil-felsokning": "husbilens-elsystem-12v-230v-guide-fricamping",

  // Gasol
  "gasol-husbil-regulator-sakerhet-byte-guide": "gasol-husbil-regler-provtryckning-byte-guide",
  "gasol-husbil-sakerhet": "gasol-husbil-regler-provtryckning-byte-guide",

  // Värme
  "alde-panna-byte-verkstad-kostnad-2026": "valja-ratt-varme-husbil-husvagn-truma-alde-diesel",

  // Vinter
  "vinterforvaring-husbil": "vinterkora-och-forvara-husbil-norrland-guide",
  "vinterforvaring-husbil-checklista-kalix": "vinterkora-och-forvara-husbil-norrland-guide",
  "husbil-vinterkorning-norrbotten-guide": "vinterkora-och-forvara-husbil-norrland-guide",

  // Däck
  "dack-och-lufttryck-husbil-guide": "husbilens-dack-tryck-lastindex-sakerhetsguide",
  "reservdack-husbil-vs-punkteringsspray-guide": "husbilens-dack-tryck-lastindex-sakerhetsguide",

  // Vatten och avlopp
  "toalett-och-svartvatten-husbil-guide": "vattensystem-husbil-husvagn-underhall-checklista",
  "vatten-avlopp-husbil": "vattensystem-husbil-husvagn-underhall-checklista",

  // Underhåll
  "husbil-underhall-arligt": "underhallsschema-husbil-aret-runt-servicear",

  // Körkort
  "korkort-husbil-vad-galler": "b-korkort-husbil-totalvikt-c1-regler",
  "husbil-b-korkort-3500-kg-c1-praktiken": "b-korkort-husbil-totalvikt-c1-regler",
  "husbil-b-korkort-c1-viktgrans-guide": "b-korkort-husbil-totalvikt-c1-regler",

  // Vatten – en enda komplett checklista
  "underhall-vattensystem-husbil-husvagn-steg-for-steg":
    "vattensystem-husbil-husvagn-underhall-checklista",

  // Däck – en enda komplett guide
  "dack-tryck-lastindex-husbil-husvagn-sakerhet": "husbilens-dack-tryck-lastindex-sakerhetsguide",


  // Första resan
  "forsta-resan-husbil": "forsta-husbilsresan-guide-for-nyborjare",

  // Hund och barn
  "husbil-med-hund": "hund-i-husbil-guide-sakerhet-ventilation-att-tanka-pa",
  "barn-i-husbil": "basta-husbilen-for-barnfamilj-planlosning-sangtyper",

  // Hyra ut
  "hyra-ut-husbilen-privat-forsakring-skatt-avtal":
    "hyra-ut-husbil-ekonomi-forsakring-slitage-kalkyl",

  // Renovering – en enda komplett kalkyl
  "renovera-aldre-husvagn-nar-lonar-det-sig": "renovera-husvagn-kalkyl-fuktskada-lonar-det-sig",

  // Husbil eller husvagn
  "husbil-eller-husvagn": "husbil-eller-husvagn-vad-passar-dig",
};

export const BLOG_REDIRECT_SLUGS = Object.keys(BLOG_REDIRECTS);
